<script>
  import { tempStore } from "../../../stores/temp.store";
  import { configStore } from "../../../stores/config.store";
  import { onMount } from "svelte";
  import { viditelnostTabu } from "../sidebarLeft.func";
  import {
    vratUlozeneVrstvy,
    opravPrepinacVsetkychVrstiev,
    ziskajVrstvy,
  } from "./vrstvy.func";
  import VrstvySub from "./VrstvySub.svelte";
  import get from "get-value";

  const kodMenu = "vrstvy";
  let open = false;
  let vrstvy = [];

  const unsubscribe = tempStore.subscribe((value) => {
    viditelnostMenu(value);
  });

  function viditelnostMenu(value) {
    let menu = get(value, "menu");
    open = kodMenu === menu;
  }

  const ulozeneVrstvy = vratUlozeneVrstvy();

  onMount(async () => {
    vrstvy = await ziskajVrstvy();
    setTimeout(() => opravPrepinacVsetkychVrstiev(), 100);
  });
</script>

<!-- Tab change map start -->
<div
  class="sidebar__tab sidebar__tab--map"
  class:js-tab--open={open}
  data-tab="2"
  id="tabVrstvy"
  on:mouseleave|preventDefault={() => viditelnostTabu(kodMenu)}
>
  <!-- <div
    class="sidebar__close"
    on:click|preventDefault={() => viditelnostTabu(kodMenu)}
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50.8 35.4">
      <path
        d="M16.5 35c.8.6 1.9.6 2.5-.2.6-.7.6-1.6 0-2.3L6.1 19.6h42.6c1 0 1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8H6.1l13-12.9c.7-.7.7-1.8 0-2.5s-1.8-.7-2.5 0l-16 16c-.7.7-.7 1.8 0 2.5L16.5 35z"
      />
    </svg>
  </div> -->
  <div class="sidebar__wrapper">
    <nav class="accordion arrows">
      <header class="box-header">
        <label for="acc-close" class="box-title">Vrstvy</label>
      </header>

      <!-- <VrstvySub expanded vrstvy={$configStore.vrstvy} /> -->
      {#each vrstvy as vrstva}
        <VrstvySub
          name={vrstva.name}
          childNodes={vrstva.childNodes && vrstva.childNodes.length
            ? vrstva.childNodes
            : null}
          input_type={vrstva.input_type}
          {ulozeneVrstvy}
        />
      {/each}
    </nav>
  </div>
</div>
